import { logger } from "cayo.ui";
import { endpoints } from "@cayo/shared/services/endpoints.service";
import tokenStorage from "@cayo/shared/settings/tokenStorage";
import { clearAuthData } from "../utils/clearAuthData";

const log = logger.getLogger("action-handlers");

export const customLogout = async (logoutUrl: string) => {
  const idToken = tokenStorage.getToken()?.id_token;

  clearAuthData();

  if (!idToken) {
    log.error("No id_token found, cannot perform logout with custom logout URL");

    window.location.reload();
    return;
  }

  const redirectUrl = encodeURIComponent(endpoints.publicUrl);
  logoutUrl += `?post_logout_redirect_uri=${redirectUrl}&client_id=${"cayo.admin.web"}&id_token_hint=${idToken}`;

  window.location.assign(logoutUrl);
};
